import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';

import { sortCountries } from 'helpers/helpers';
import FormTextField from 'components/FormFields/FormTextField';
import FormSelectField from 'components/FormFields/FormSelectField';

import { AddressData } from 'stores/workflowStores/workflowPersonalDataStore/model';

interface Props {
  readOnly?: boolean;
  prefix: string;
  addressType: string;
  countries?: string[];
  country?: string;
  address?: AddressData;
  handleCitizenshipChange?: () => void;
}

const Address = (props: Props) => {
  const { t } = useTranslation();
  const { address } = props;
  return (
    <>
      <Grid container>
        {props.address !== undefined ? (
          <>
            <Grid item xs={12} sm={6}>
              <FormTextField
                name="street"
                value={address!.street}
                label={t('general_street')}
                fast={false}
                readOnly
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormTextField
                name="landRegistryNumber"
                value={address!.landRegistryNumber}
                label={t('general_landRegistryNumber')}
                fast={false}
                readOnly
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormTextField
                name="houseNumber"
                value={address!.houseNumber}
                label={t('general_houseNumber')}
                fast={false}
                readOnly
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormTextField
                name="city"
                value={address!.city}
                label={t('general_city')}
                fast={false}
                readOnly
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormTextField
                name="postalCode"
                value={address!.postalCode}
                label={t('general_postalCode')}
                fast={false}
                readOnly
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormTextField
                name="country"
                value={t(`country_${address!.country}`)}
                label={t('general_country')}
                fast={false}
                readOnly
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sm={6}>
              <FormTextField
                name={`${props.prefix}${props.addressType}.street`}
                label={t('general_street')}
                readOnly={props.readOnly}
                fast={false}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormTextField
                name={`${props.prefix}${props.addressType}.landRegistryNumber`}
                label={t('general_landRegistryNumber')}
                readOnly={props.readOnly}
                fast={false}
                maxLength={8}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormTextField
                name={`${props.prefix}${props.addressType}.houseNumber`}
                label={t('general_houseNumber')}
                readOnly={props.readOnly}
                fast={false}
                maxLength={4}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormTextField
                name={`${props.prefix}${props.addressType}.city`}
                label={t('general_city')}
                readOnly={props.readOnly}
                fast={false}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <FormTextField
                name={`${props.prefix}${props.addressType}.postalCode`}
                label={t('general_postalCode')}
                readOnly={props.readOnly}
                fast={false}
                maxLength={8}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              {props.readOnly ? (
                <FormTextField
                  name={`${props.prefix}${props.addressType}.country`}
                  label={t('general_country')}
                  value={t(`country_${props.country}`)}
                  readOnly
                />
              ) : (
                <FormSelectField
                  name={`${props.prefix}${props.addressType}.country`}
                  label={t('general_country')}
                  options={
                    props.countries &&
                    sortCountries(
                      props.countries.map((code) => ({
                        value: code,
                        label: t(`country_${code}`),
                      })),
                    )
                  }
                  afterChange={props.handleCitizenshipChange}
                />
              )}
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default Address;
